import { z } from 'zod';

/** A field value on the wire: a scalar, or `null` to clear it. */
export const IntegrationConfigValueSchema = z.union([
  z.string(),
  z.number(),
  z.boolean(),
  z.null(),
]);

export type IntegrationConfigValue = z.infer<typeof IntegrationConfigValueSchema>;

/**
 * Writing one provider's configuration.
 *
 * The wire schema can only check shape — which fields exist, what type each one
 * takes, and whether the provider is real are all catalog facts checked on the
 * server (422). Two semantics ride on a blank string, and both are deliberate
 * (N21):
 *
 * - a **secret** written blank **keeps** the stored value, because the admin
 *   never receives it and so cannot echo it back;
 * - a **non-secret** written blank (or explicitly `null`) **clears** the field,
 *   which falls back to the catalog's `envVar` if one is declared.
 */
export const WriteIntegrationConfigSchema = z
  .object({
    values: z
      .record(z.string(), IntegrationConfigValueSchema)
      .refine((values) => Object.keys(values).length > 0, {
        message: 'Write at least one field.',
      }),
  })
  .strict();

export type WriteIntegrationConfigRequest = z.infer<typeof WriteIntegrationConfigSchema>;
